import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, TextField } from "@mui/material";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

const schema = yup.object({
  serialNumber: yup.number().required("SerialNumber number is required"),
});

type FormData = {
  serialNumber: number;
};

type Props = {
  onSubmit: (data: FormData) => void;
  showImageEnabled: boolean;
  onShowImageClick: () => void;
};

export type ModuleSearchBySerialNumberRef = {
  reset: () => void;
};

const ModuleSearchBySerialNumber = forwardRef<ModuleSearchBySerialNumberRef, Props>(
  ({ onSubmit, showImageEnabled, onShowImageClick }, ref) => {
    const {
      handleSubmit,
      setValue,
      reset,
      formState: { errors, isSubmitting },
      watch,
    } = useForm<FormData>({
      resolver: yupResolver(schema),
      defaultValues: { serialNumber: undefined },
    });

    useImperativeHandle(ref, () => ({
      reset: () => reset(),
    }));
    const trackingValue = watch("serialNumber");

    const inputRef = useRef<HTMLInputElement | null>(null);

    return (
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        display="flex"
        alignItems="center"
        gap={2}
        sx={{ mb: 2 }}
      >
        <TextField
          inputRef={inputRef}
          label="Enter SerialNumber"
          variant="outlined"
          size="small"
          value={trackingValue ?? ""}
          onChange={(e) =>
            setValue("serialNumber", Number(e.target.value), {
              shouldDirty: true,
              shouldTouch: true,
            })
          }
          error={!!errors.serialNumber}
          helperText={errors.serialNumber?.message}
        />

        <Button type="submit" variant="outlined" disabled={isSubmitting}>
          {isSubmitting ? "SEARCHING..." : "SEARCH"}
        </Button>

        <Button
          variant="outlined"
          disabled={!showImageEnabled}
          onClick={onShowImageClick}
        >
          SHOW EL-IMAGE
        </Button>
      </Box>
    );
  }
);

export default ModuleSearchBySerialNumber;
